<dx-toolbar [elementAttr]="{ class: 'conference-registration-grid__toolbar' }">
  <dxi-item location="before" width="100px">
    <div *dxTemplate>
      <h5 class="ag-grid__toolbar-title">Event Registrations</h5>
    </div>
  </dxi-item>

  <dxi-item location="after" cssClass="ag-grid__toolbar-control">
    <ng-container>
      <div *dxTemplate>
        <dx-select-box
          #conferenceSelectBox
          [width]="450"
          labelMode="floating"
          label="Event"
          [value]="conferenceDbId$ | async"
          (valueChange)="setConferenceDbId($event)"
          [valueExpr]="'conferenceDbId'"
          [displayExpr]="'description'"
          [dataSource]="conferences$ | async"
          [dropDownOptions]="{ minWidth: '450px' }"
          [readOnly]="!showConferenceSelectBox"
        ></dx-select-box>
      </div>
    </ng-container>
  </dxi-item>

  <dxi-item
    location="after"
    cssClass="ag-grid__toolbar-control"
    widget="dxButton"
    [options]="{ icon: 'refresh', text: lastUpdateDate$ | async, onClick: forceRefresh }"
  >
  </dxi-item>
</dx-toolbar>

<div class="conference-registration-grid__accordion-container">
  <dx-accordion
    #accordionRef
    [collapsible]="false"
    [multiple]="false"
    [animationDuration]="300"
    [elementAttr]="{ class: 'conference-registration-grid__accordion' }"
    [deferRendering]="true"
    height="100%"
  >
    <dxi-item *ngIf="embeddedFormEnabled$ | async" icon="agi-participant-plus" title="Requests for Attendance">
      <div *dxTemplate>
        <ag-crm-participation-requests-grid *ngIf="accordionRef.visible"></ag-crm-participation-requests-grid>
      </div>
    </dxi-item>

    <dxi-item icon="agi-participants" title="Invited Participants">
      <div *dxTemplate>
        <app-invited-participants-grid *ngIf="accordionRef.visible"></app-invited-participants-grid>
      </div>
    </dxi-item>

    <dxi-item icon="agi-participant-minus" title="Denied Participants">
      <div *dxTemplate>
        <app-rejected-participants-grid *ngIf="accordionRef.visible"></app-rejected-participants-grid>
      </div>
    </dxi-item>
  </dx-accordion>
</div>

<!--
  No refresh on close: registrants$ is a live listener, so the grid is already current by the time
  the modal shuts. Re-running the query here tore down a healthy listener and attached a new one,
  which is what exposed the cache-first snapshot and could leave the grid showing a partial roster.
-->
<ag-crm-attendee-details-modal #attendeeDetailsModalRef></ag-crm-attendee-details-modal>

<ng-container *ngIf="agentDetailsModalVisible$ | async as agentDetailsModalVisible">
  <dx-popup
    title="Agent Details"
    [showTitle]="true"
    [fullScreen]="true"
    [showCloseButton]="true"
    [dragEnabled]="false"
    [wrapperAttr]="{ class: 'ag-overlay-popup' }"
    [visible]="agentDetailsModalVisible"
    (onHidden)="onAgentModalHidden()"
  >
    <dx-load-indicator
      *ngIf="(selectedAgent$ | async) == null; else agentEditorTmp"
      [visible]="true"
    ></dx-load-indicator>

    <ng-template #agentEditorTmp>
      <app-agent-editor [selectedAgent]="selectedAgent$ | async"></app-agent-editor>
    </ng-template>
  </dx-popup>
</ng-container>
